import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'


export class ImageText
{
  constructor(block) {

    let startVal = 'top +=65%'
    let endVal = 'bottom -=65%'

    if(window.innerWidth < 700) {
      startVal = 'top +=85%'
      endVal = 'bottom -=85%'
    }

    this.img = block.querySelector('img')
    this.contentWrapper = block.querySelector('.content-wrapper')

    if(this.img) {
      gsap.set(this.img, { scale: 1.2 })
    }

    gsap.set(this.contentWrapper, { scale: 0.9, y: 100 })


    const self = this

    ScrollTrigger.create({
      trigger: block,
      start: startVal,
      end: endVal,
      once: true,
      onEnter: () => {

        if(self.img) {
          gsap.to(self.img, { scale: 1, opacity: 1, delay: 0.2, duration: 0.75 })
        }
        gsap.to(self.contentWrapper, { scale: 1,y: 0, duration: 0.75 })
      }

    })


  }
}

const heroBlocks = document.querySelectorAll('.block-image-text')
heroBlocks.forEach( block => {
  new ImageText(block)
})
